<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h2>Scheduler</h2>
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <ul class="nav nav-tabs outer">
          <li class="nav-item">
            <router-link :to="{ name: 'CalendarScheduler' }" class="nav-link">Calendar</router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'DayScheduler' }" class="nav-link">Day</router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'DefaultScheduler' }" class="nav-link">Default</router-link>
          </li>
        </ul>
        <br>
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      logged_in_user: 'loggedInUser'
    })
  }
}
</script>
